const state = {
  showImageColorPicker: false,
  showPhotoScopable: false
}

const getters = {
  getShowImageColorPicker: state => state.showImageColorPicker,
  getShowPhotoScopable: state => state.showPhotoScopable
}

const actions = {}

const mutations = {
  'SHOW_IMAGE_COLORPICKER_POPUP': (state, showImageColorPicker) => { state.showImageColorPicker = showImageColorPicker },
  'SHOW_PHOTO_SCOPABLE_POPUP': (state, showPhotoScopable) => { state.showPhotoScopable = showPhotoScopable }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
